exports.langs = {
    de:        'german',
    en:        'english',
    es:        'spanish',
    fi:        'finnish',
    fr:        'french',
    it:        'italian',
    ja:        'japanese',
    nl:        'dutch',
    pt:        'portuguese',
    ru:        'russian',
    sv:        'swedish',
    lp:        'pig latin',
    zh:        'chinese',
    'zh-Latn': 'chinese (pinyin)'
};

exports.langsNative = {
    de:        'deutsch',
    en:        'english',
    es:        'español',
    fi:        'suomi',
    fr:        'français',
    it:        'italiano',
    ja:        '日本語',
    nl:        'nederlands',
    pt:        'português',
    ru:        'Русский язык',
    sv:        'svenska',
    lp:        'igpay atinlay',
    zh:        '中文',
    'zh-Latn': 'Zhōngguó pīnyīn'
};



/** WEBPACK FOOTER **
 ** ./src/translate/langs.js
 **/